import React from 'react'

import { LntModal } from '@app/components/base'

import { ScheduleChangeForm } from '../ScheduleChangeForm'

import type { ScheduleChangeModalProps } from './types'

export const ScheduleChangeModal: React.FC<ScheduleChangeModalProps> = ({ onScheduleChange, ...props }) => {
  return (
    <LntModal
      { ...props }
      title='Изменение дат'
      width={ 572 }
      footer={ null }
    >
      <ScheduleChangeForm onScheduleChange={ onScheduleChange } />
    </LntModal>
  )
}
